/**
 * @file Table atom — tabular data compound family.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/Table
 */
export {
  Table,
  TableBody,
  TableCaption,
  TableData,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
